module.exports = __webpack_public_path__ + "fonts/LidlFontPro-Italic.woff2";